const openRoutes = ['login', 'visitor-validation']

export async function addAuthTokenToRequest(config) {
  if (openRoutes.some(route => config.url.includes(openRoutes))) return config

  const token = window.sessionStorage.getItem('token')

  const authorization = `Bearer ${token}`

  const updatedConfig = {
    ...config,
    headers: {
      ...config.headers,
      authorization,
    },
  }

  return updatedConfig
}
